/**
 * widgets/app-shell/ui/BootstrapSplash — shown while the session store
 * is performing its initial bootstrap (GET /me / token refresh).
 *
 * Prevents protected content from flashing or triggering a premature
 * redirect to login during the async bootstrap cycle.
 */

import { useTranslation } from 'react-i18next';

export function BootstrapSplash() {
  const { t } = useTranslation('common');

  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={t('app.loading')}
      data-testid="bootstrap-splash"
      className="flex min-h-screen items-center justify-center bg-background"
    >
      <div className="flex flex-col items-center gap-4">
        {/* Spinner ring */}
        <span
          aria-hidden="true"
          className="h-10 w-10 animate-spin rounded-full border-4 border-muted border-t-primary"
        />
        <p className="text-sm text-muted-foreground">{t('app.loading')}</p>
      </div>
    </div>
  );
}
